// extracted by mini-css-extract-plugin
module.exports = {"main":"Histories_main__V7ktc","title":"Histories_title__2xvfR","tabsDiv":"Histories_tabsDiv__kLxxC"};